import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AdminLoading from './AdminLoading';
import AdminEmptyState from './AdminEmptyState';
import { IoArrowUpOutline } from 'react-icons/io5';

export default function AdminRentalOutward() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    api('/api/admin/rental/outward')
      .then((data) => { setList(data); setError(''); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => load(), []);

  const handleMarkDispatched = async (orderId) => {
    setError('');
    try {
      await api(`/api/admin/rental/outward/${orderId}`, { method: 'POST' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <AdminLoading />;

  return (
    <>
      <Card>
        <CardHeader title="Outward" subheader="Orders out for delivery or delivered" />
        <CardContent>
          {error && <Typography color="error" className="admin-error" sx={{ mb: 2 }}>{error}</Typography>}
          {list.length === 0 ? (
            <AdminEmptyState message="No orders in outward." icon={IoArrowUpOutline} />
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Order</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Event date</TableCell>
                    <TableCell>Return by</TableCell>
                    <TableCell>Contact</TableCell>
                    <TableCell>Items</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list.map((o) => (
                    <TableRow key={o.id} hover>
                      <TableCell>#{o.id}</TableCell>
                      <TableCell>{o.status?.replace(/_/g, ' ')}</TableCell>
                      <TableCell>{o.event_date}</TableCell>
                      <TableCell>{o.return_by}</TableCell>
                      <TableCell>{o.contact_name || o.contact_email || '–'}</TableCell>
                      <TableCell>
                        {o.items?.map((it) => (
                          <Box key={it.order_item_id} component="span" sx={{ display: 'block' }}>
                            {it.product_name} × {it.quantity}
                          </Box>
                        ))}
                      </TableCell>
                      <TableCell align="right">
                        {(o.status === 'confirmed' || !o.items?.[0]?.tracking_status) && (
                          <Button size="small" variant="contained" onClick={() => handleMarkDispatched(o.id)}>
                            Mark dispatched
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </>
  );
}
